import PropTypes from 'prop-types';
import React from 'react'
import { Link } from 'react-router-dom'

import TextEdit from '~/services/textedit'


export default class extends React.Component {
    static propTypes = {
		articles: PropTypes.array.isRequired
	};

    render() {
    	let { articles } = this.props;

		return (
			<div className="latest-holder narrow-gutter">
				{ articles.map( article => {
	        		return(
                        <div className="latest-article row full-height" key={'latest-article-'+article.ID}>
                            <div className="col-xs-4 col-md-3">
                                <Link
									to={article.link}
									state={{article: article}}
									target={article.external ? '_blank' : '_self'}
								>
                                    <img src={article.images.square} className="img-responsive" />
                                </Link>
                            </div>
                            <div className="col-xs-8 col-md-9 content-block match-height">
                                <h5 className="mtop0 mbot0">
                                    <Link
										to={article.link}
										state={{article: article}}
										target={article.external ? '_blank' : '_self'}
										className="text-dark-gray"
									>
                                        { article.title }
                                    </Link>
                                </h5>
                            </div>
                        </div>
					);
	        	}) }
        	</div>
		)
		
	}
}



// WEBPACK FOOTER //
// ./src/js/views/Discover/scenes/Unfiltered/components/Latest.jsx